/** @format */
import React, { useState } from 'react';
import moment from 'moment';
import appConfig from 'config/app';
import { useSelector } from 'react-redux';
import {
  faXmarkCircle,
  faCircleCheck
} from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { setApprovalStatusOnOwnerOnboardingRequest } from 'services/apiService';
import ButtonSyncLoader from 'components/ButtonSyncLoader';

export const ExpandableTableRow = ({ rowData, rowMeta }) => {
  const { dataIndex } = rowMeta || {};

  const [isStatusChangeRequesting, setIsStatusChangeRequesting] =
    useState(false);

  const onboardData = useSelector((state) => state.ownerOnboardData);
  const data = onboardData.data[dataIndex];

  const handleStatusChange = async (statusType, id) => {
    setIsStatusChangeRequesting(true);
    try {
      // await new Promise((resolve) => {
      //   setTimeout(() => {
      //     resolve();
      //   }, 2000);
      // });
      const response = await setApprovalStatusOnOwnerOnboardingRequest(
        statusType,
        {
          ownerId: id
        }
      );

      console.log('-----approval response', response);

      data.onboardingStatus = response?.data?.data?.approvalStatus;
    } catch (error) {
      console.error('Error approving owner onboarding request:', error);
    } finally {
      setIsStatusChangeRequesting(false);
    }
  };

  const ListItem = ({
    label,
    value,
    unit = null,
    type = null,
    data = {},
    valueKey = undefined
  }) => {
    if (value) {
      if (type) {
        switch (type) {
          case 'date': {
            return (
              <li>
                <span>{label} : </span>
                {moment(value).format(appConfig.defaultMomentDateTimeFormat)}
              </li>
            );
          }

          case 'para': {
            return (
              <li>
                <span>{label} : </span>
                <p>{value}</p>
              </li>
            );
          }
          case 'fm_object_profile': {
            return (
              <li>
                <div className='button-item-container'>
                  <span>{label} : </span>
                  <p>{value}</p>{' '}
                  <button
                    className='btn btn-pink'
                    onClick={() => {
                      window.open(
                        `https://friamaklare.se/objekt/${data?.objectId}`,
                        '_blank'
                      );
                    }}>
                    View Object
                  </button>
                </div>
              </li>
            );
          }
          case 'urgency': {
            if (valueKey === 'urgent') {
              return (
                <li
                  style={{
                    color: 'red'
                  }}>
                  <span>{label} : </span>
                  {value}
                </li>
              );
            } else {
              return (
                <li>
                  <span>{label} : </span>
                  {value}
                </li>
              );
            }
          }
          default: {
            return (
              <li>
                <span>{label} : </span>
                {value}
              </li>
            );
          }
        }
      } else {
        if (Array.isArray(value)) {
          if (value.length > 0) {
            return (
              <li>
                <span>{label} : </span>
                {value.join(',')}
              </li>
            );
          }
        } else {
          return (
            <li>
              <span>{label} : </span>
              {value} {unit && <span>{unit}</span>}
            </li>
          );
        }
      }
    }
  };

  return (
    <tr className='leads-data-row-expanded'>
      <td colSpan={rowData.length + 1}>
        <div className='leads-data-row-expanded-container owner-onboarding-expanded-container'>
          <ul>
            <ListItem label='Name' value={data?.name} />
            <ListItem
              label='Broker Status'
              value={data?.status?.toUpperCase()}
            />
            <ListItem
              label='Received at'
              value={data?.receivedAt}
              type='date'
            />
            <ListItem label='Email' value={data?.email} />
            <ListItem label='Phone' value={data?.phone} />
            <ListItem label='City' value={data?.city} />
            <ListItem
              label='Interested Companies'
              value={data?.interestedCompanyTypes}
            />
            <ListItem label='Company Name' value={data?.companyName} />
            <ListItem label='Slogan' value={data?.slogan} />
            <ListItem
              label='Business purpose'
              value={data?.businessPurpose}
              type='para'
            />
          </ul>

          <div className='owner-onboarding-expanded-buttons-container'>
            {data.onboardingStatus === 'registered' ? (
              <>
                <Button
                  disabled={isStatusChangeRequesting}
                  className={'btn btn-pink'}
                  onClick={() => {
                    handleStatusChange('approve', data?.id);
                    // activateDeactivateBrokerHandler(row.brokerId, 'activate');
                  }}>
                  {isStatusChangeRequesting ? (
                    <ButtonSyncLoader />
                  ) : (
                    <>
                      <FontAwesomeIcon
                        icon={faCircleCheck}
                        size='lg'
                        color='white'
                      />
                      Approve
                    </>
                  )}
                </Button>
                <Button
                  // disabled={isStatusChangeRequesting}
                  className={'btn btn-white'}
                  onClick={() => {
                    handleStatusChange('decline', data?.id);
                    // activateDeactivateBrokerHandler(row.brokerId, 'deactivate');
                  }}>
                  {isStatusChangeRequesting ? (
                    <ButtonSyncLoader />
                  ) : (
                    <>
                      <FontAwesomeIcon
                        icon={faXmarkCircle}
                        size='lg'
                        color='var(--color-neutral-dark-600)'
                      />
                      Decline
                    </>
                  )}
                </Button>
              </>
            ) : (
              <span
                style={{
                  backgroundColor: 'white',
                  color: 'black',
                  padding: '5px 10px',
                  borderRadius: '5px'
                }}>
                {data.onboardingStatus?.replace('_', ' ')?.toUpperCase()}
              </span>
            )}
          </div>
        </div>
      </td>
    </tr>
  );
};
